module.exports = __webpack_public_path__ + "img/qr-code-generate.5a9a13a0.svg";